export const PRESETS = [
  { amount: 25, impact: "covers wrapping paper and tape for one store box" },
  { amount: 50, impact: "buys a toy for one patient" },
  { amount: 100, impact: "funds a U-Haul rental" },
];

export const DEFAULT_IMPACT = "helps bring the holidays to kids in treatment";

export const impactFor = (amount) => PRESETS.find((p) => p.amount === Number(amount))?.impact || DEFAULT_IMPACT;

export function money(v) {
  const n = Number(v) || 0;
  const cents = Math.round(n * 100) % 100 !== 0;
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: cents ? 2 : 0,
  });
}

export const percent = (part, whole) => (whole > 0 ? Math.round((part / whole) * 100) : 0);

export function parseAmount(raw) {
  const s = String(raw ?? "").replace(/[$,\s]/g, "");
  if (!/^\d+(\.\d{1,2})?$/.test(s)) return null;
  const n = Number(s);
  return n >= 1 ? n : null;
}

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || "").trim());
